<template>
    <div class="cart-delivery-section"
         :class="{ 'active' : stepOneValid }">
        <h3 ref="cartDeliveryPayment">
            <span v-show="!stepTwoValid" class="step-icon">2</span>
            <span v-show="stepTwoValid" class="step-icon">
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.79321 8.38865C4.69478 8.48766 4.56048 8.5429 4.42098 8.5429C4.28149 8.5429 4.14719 8.48766 4.04876 8.38865L1.0761 5.4155C0.767602 5.10701 0.767602 4.60676 1.0761 4.29884L1.44832 3.92652C1.75692 3.61802 2.25658 3.61802 2.56508 3.92652L4.42098 5.78252L9.4359 0.767506C9.7445 0.459008 10.2446 0.459008 10.5527 0.767506L10.9249 1.13982C11.2334 1.44832 11.2334 1.94847 10.9249 2.25649L4.79321 8.38865Z" fill="white"/>
                </svg>
            </span>
            Выберите способ оплаты
        </h3>

        <div v-if="stepOneValid" class="cart-delivery-payment">
            <div class="cart-delivery-options">
                <div v-for="payment in deliveryPayments" class="cart-delivery-option">
                    <q-radio
                        :id="'delivery-payment-' + payment.payment_type_id"
                        name="delivery-payment"
                        :val="payment.payment_type_id"
                        v-model="payment_type_id"
                        :disable="payment.min_cost > totalPrice || !payment.availability"
                    >
                        <template v-slot:default>
                            <svg v-if="payment.payment_type_id === 3" viewBox="0 0 182 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#headerLogoDolyame)" fill="#000">
                                    <path
                                        d="M146.228 12.548l-7.012-7.766h-4.099v17.981h4.28V11.291l6.401 6.797h.791l6.292-6.797v11.472h4.28V4.782h-4.099l-6.834 7.766zM177.552 4.782l-10.608 11.687V4.782h-4.28v17.981h3.921l10.608-11.687v11.687h4.28V4.782h-3.921zM112.064 11.361c0 2.863 1.572 5.119 3.984 6.064l-4.523 5.338h5.238l4.115-4.856h4.453v4.856h4.28V4.782h-10.896c-4.063 0-6.651 2.768-6.651 6.58zm13.27-2.619v5.317h-5.826c-1.943 0-2.986-1.079-2.986-2.66 0-1.583 1.08-2.662 2.986-2.662l5.826.005zM92.176 8.378c-.262 6.184-1.572 10.176-4.136 10.176h-.642v4.317l.684.036c5.142.286 7.984-4.209 8.45-14.026h6.763v13.882h4.272V4.782H92.32l-.144 3.596zM76.065 4.53c-5.789 0-9.954 3.992-9.954 9.241 0 5.43 4.532 9.28 9.954 9.28 5.647 0 10.034-4.065 10.034-9.28 0-5.215-4.387-9.24-10.034-9.24zm0 14.205c-3.272 0-5.5-2.122-5.5-4.964 0-2.913 2.23-4.977 5.5-4.977 3.269 0 5.574 2.159 5.574 4.977 0 2.819-2.337 4.964-5.574 4.964zM61.572 4.815H46.467l-.145 3.597c-.214 5.18-1.571 10.108-4.136 10.178L41 18.627v8.382L45.317 27v-4.235h14.995V27h4.353v-8.41h-3.093V4.815zm-4.28 13.775H48.16c1.545-2.336 2.373-5.718 2.517-9.673h6.616v9.673zM31 .5h-4v22h4V.5zM4 5H0v22h4V5zM13 3.5H9v22h4v-22zM22 2h-4v22h4V2z"></path>
                                </g>
                                <defs>
                                    <clipPath id="headerLogoDolyame"><path fill="#fff" d="M0 0h182v27H0z"></path></clipPath>
                                </defs>
                            </svg>
                            <span v-else v-html="paymentTypeName(payment.payment_type_id)"></span>
                            <span v-if="payment.min_cost && payment.min_cost > totalPrice">
                                <br><span>при заказе от {{ payment.min_cost }} руб.</span>
                            </span>
                        </template>
                    </q-radio>
                </div>

                <div v-if="hasError('payment_type_id')" class="invalid-feedback d-block">
                    {{ getError('payment_type_id') }}
                </div>
            </div>

            <ul class="cart-delivery-features">
                <li class="parts-pay-info" v-if="payment_type_id === 3">
                    <div class="parts-pay-scheme">
                        <div v-for="(weeks,part) in {25:0,50:2,75:4,100:6}" class="parts-pay-step">
                            <div class="parts-pay-price">{{ (totalPrice/4).toFixed(2) }}</div>
                            <div class="parts-pay-date">{{ weeks? `Через ${weeks} недели` : 'Сегодня'}}</div>
                            <div class="parts-pay-progress">
                                <div class="icon" :class="`step-${part}`"></div>
                                <div v-if="weeks !== 6" class="parts-pay-line"></div>
                            </div>
                        </div>
                    </div>
                    <p class="parts-pay-feature"><span class="ok icon" />Оплачивайте покупки частями — по 25% каждые две недели</p>
                    <p class="parts-pay-feature"><span class="ok icon" />Никаких дополнительных платежей — как обычная оплата картой</p>
                </li>
                <li v-if="payment_type_id" class="list-delivery">Стоимость доставки - {{ deliveryCost }}</li>
                <li v-if="payment_type_id === 1" class="list-payment">Оплата наличными или по карте</li>
                <li v-if="fittingAvailable" class="list-warning">
                    Доступна примерка
                    <q-btn @click="switchTooltips('fittingAvailableTooltip')" flat>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.99996 18.3333C14.6023 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6023 1.66666 9.99996 1.66666C5.39759 1.66666 1.66663 5.39762 1.66663 9.99999C1.66663 14.6024 5.39759 18.3333 9.99996 18.3333Z" stroke="#24AAFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.22168 12.2832C9.22168 11.7204 9.2915 11.2718 9.43115 10.9375C9.5708 10.6032 9.84587 10.2371 10.2563 9.83936C10.6711 9.43734 10.9334 9.15169 11.0435 8.98242C11.2127 8.72428 11.2974 8.44499 11.2974 8.14453C11.2974 7.74674 11.1979 7.44417 10.999 7.23682C10.8044 7.02523 10.5166 6.91943 10.1357 6.91943C9.77181 6.91943 9.4777 7.02311 9.25342 7.23047C9.03337 7.43359 8.92334 7.71077 8.92334 8.06201H7.38086C7.38932 7.31299 7.64323 6.72054 8.14258 6.28467C8.64616 5.8488 9.31055 5.63086 10.1357 5.63086C10.9863 5.63086 11.6486 5.84668 12.1226 6.27832C12.6007 6.70996 12.8398 7.31299 12.8398 8.0874C12.8398 8.77718 12.5182 9.45638 11.875 10.125L11.0942 10.8931C10.8149 11.2104 10.6711 11.6738 10.6626 12.2832H9.22168ZM9.11377 14.2573C9.11377 14.0076 9.19206 13.8066 9.34863 13.6543C9.50521 13.4977 9.7168 13.4194 9.9834 13.4194C10.2542 13.4194 10.4679 13.4998 10.6245 13.6606C10.7811 13.8172 10.8594 14.0161 10.8594 14.2573C10.8594 14.4901 10.7832 14.6847 10.6309 14.8413C10.4785 14.9979 10.2627 15.0762 9.9834 15.0762C9.7041 15.0762 9.48828 14.9979 9.33594 14.8413C9.18783 14.6847 9.11377 14.4901 9.11377 14.2573Z" fill="#24AAFF"/>
                        </svg>
                        <q-tooltip v-model="fittingAvailableTooltip" anchor="top middle" self="bottom middle">
                            <p>На примерку отводиться до 15 минут в непосредственной близости от торгового представителя.</p>
                        </q-tooltip>
                    </q-btn>
                </li>
                <li class="list-warning" v-if="this.payment_type_id !== '' && !fittingAvailable">Примерка не доступна</li>
                <li v-if="partialPaymentAvailable" class="list-warning" @click="switchTooltips('partialPaymentAvailableTooltip')">
                    Доступен частичный выкуп
                    <q-btn flat>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.99996 18.3333C14.6023 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6023 1.66666 9.99996 1.66666C5.39759 1.66666 1.66663 5.39762 1.66663 9.99999C1.66663 14.6024 5.39759 18.3333 9.99996 18.3333Z" stroke="#24AAFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.22168 12.2832C9.22168 11.7204 9.2915 11.2718 9.43115 10.9375C9.5708 10.6032 9.84587 10.2371 10.2563 9.83936C10.6711 9.43734 10.9334 9.15169 11.0435 8.98242C11.2127 8.72428 11.2974 8.44499 11.2974 8.14453C11.2974 7.74674 11.1979 7.44417 10.999 7.23682C10.8044 7.02523 10.5166 6.91943 10.1357 6.91943C9.77181 6.91943 9.4777 7.02311 9.25342 7.23047C9.03337 7.43359 8.92334 7.71077 8.92334 8.06201H7.38086C7.38932 7.31299 7.64323 6.72054 8.14258 6.28467C8.64616 5.8488 9.31055 5.63086 10.1357 5.63086C10.9863 5.63086 11.6486 5.84668 12.1226 6.27832C12.6007 6.70996 12.8398 7.31299 12.8398 8.0874C12.8398 8.77718 12.5182 9.45638 11.875 10.125L11.0942 10.8931C10.8149 11.2104 10.6711 11.6738 10.6626 12.2832H9.22168ZM9.11377 14.2573C9.11377 14.0076 9.19206 13.8066 9.34863 13.6543C9.50521 13.4977 9.7168 13.4194 9.9834 13.4194C10.2542 13.4194 10.4679 13.4998 10.6245 13.6606C10.7811 13.8172 10.8594 14.0161 10.8594 14.2573C10.8594 14.4901 10.7832 14.6847 10.6309 14.8413C10.4785 14.9979 10.2627 15.0762 9.9834 15.0762C9.7041 15.0762 9.48828 14.9979 9.33594 14.8413C9.18783 14.6847 9.11377 14.4901 9.11377 14.2573Z" fill="#24AAFF"/>
                        </svg>
                        <q-tooltip v-model="partialPaymentAvailableTooltip" anchor="top middle" self="bottom middle">
                            <p>Вы выкупаете то что вам подошло и понравилось, остальное отдаете торговому представителю.</p>
                        </q-tooltip>
                    </q-btn>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';

export default {
    name: 'CartDeliveryPayment',
    data() {
        return {
            fittingAvailableTooltip: false,
            partialPaymentAvailableTooltip: false,
        }
    },
    watch: {
        deliveryPayments (newValue, oldValue) {
            if (!_.isEqual(newValue, oldValue)) {
                this.payment_type_id = '';
            }
        },
        stepOneValid (newValue) {
            if (newValue) {
                this.setErrors({});
            }
        },
        'errors' (errors) {
            if (_.intersection(_.keys(errors), ['payment_type_id']).length) {
                this.$nextTick(() => {
                    this.$refs.cartDeliveryPayment.scrollIntoView({ block: 'start', behavior: 'smooth' });
                });
            }
        },
    },
    methods: {
        ...mapMutations('cart', [
            'setErrors'
        ]),
        switchTooltips(tooltip) {
            this.fittingAvailableTooltip = false;
            this.partialPaymentAvailableTooltip = false;

            this[tooltip] = !this[tooltip];
        }
    },
    computed: {
        ...mapState('cart', [
            'form',
            'errors',
        ]),
        ...mapGetters('cart', [
            'stepOneValid',
            'stepTwoValid',
            'hasError',
            'getError',
            'totalPrice',
            'totalPriceWithoutDiscount',
            'promoCodeDiscount'
        ]),
        ...mapGetters('delivery', [
            'payments',
        ]),
        ...mapGetters('asset', [
            'paymentTypeName',
        ]),
        deliveryPayments () {
            let _this = this;

            // TODO courier only
            return _this.$store.state.cart.form.delivery_method_id
            && _this.$store.state.cart.form.service_id
            && _this.$store.state.cart.form.address.region.id
            && _this.$store.state.cart.form.address.city.id
                ? _this.payments(
                    _this.$store.state.cart.form.delivery_method_id,
                    _this.$store.state.cart.form.service_id,
                    _this.$store.state.cart.form.address.region.id,
                    _this.$store.state.cart.form.address.city.id
                )
                : [];
        },
        payment_type_id: {
            get () {
                return this.$store.state.cart.form.payment_type_id;
            },
            set (value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'payment_type_id',
                    value: value
                });
            }
        },
        fittingAvailable () {
            return (this.deliveryPayment && this.payment_type_id === 1 && this.deliveryPayment.try_on === 1);
        },
        partialPaymentAvailable () {
            return this.payment_type_id === 1;
        },
        deliveryPayment () {
            return _.find(this.deliveryPayments, d => d.payment_type_id === this.payment_type_id);
        },
        deliveryCost () {
            return this.deliveryPayment
                ? (this.deliveryPayment.cost === 0 ? 'Бесплатно' : this.deliveryPayment.cost + ' руб')
                : null;
        },
    },
}
</script>
